// extracted by mini-css-extract-plugin
export var container = "Navbar-module--container--c2dbf";
export var controls = "Navbar-module--controls--87e9d";
export var dropdown = "Navbar-module--dropdown--1adff";
export var itemIsActive = "Navbar-module--itemIsActive--742c6";
export var nav = "Navbar-module--nav--bb1e8";
export var text = "Navbar-module--text--0680a";
export var toggle = "Navbar-module--toggle--f9e12";